import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();
export const authTokenState = atom<string>({
  key: 'authTokenState',
  default: '',
  effects_UNSTABLE: [persistAtom],
});
